document.addEventListener("DOMContentLoaded", function () {

    const notifyMeHandler = function(form) {
        form.addEventListener('submit', (event) => {
            event.preventDefault();

            const formData = new FormData(form);
            const config = {
                method: 'POST',
                cache: "no-cache",
                headers: {
                    "Accept": "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: formData.get('email'),
                    variant_id: formData.get('variant_id'),
                    service_url: formData.get('service_url'),
                })
            };

            try {
                fetch('https://shopify-back-in-stock.pr-globalcms.com/product-subscribers', config)
                    .then(response => response.json())
                    .then((response) => {
                        if (!response.success) {
                            throw response.errors || 'Sorry, there is an error';
                        }
                        form.classList.add('notify_form__success');
                    })
                    .catch((error) => {
                        console.error('There was an error while submitting to Back in Stock', error);
                        form.classList.add('notify_form__error');
                    })
            } catch (error) {
                console.error('There was an error while submitting to Back in Stock', error);
                form.classList.add('notify_form__error');
            }

            return false;
        })
    };

    document.querySelectorAll('.notify_form').forEach((element) => {
        const form = element.querySelector('form');
        if (form) {
            notifyMeHandler(form);
        }
    });

});